import httpService from "@src/utility/httpService";
import { config } from '@uhg-abyss/web/tools/config';
import { PNB_CLM_DETAILS,
    PNB_NDAR_DETAILS,
    PNB_NPEM_DETAILS,
    PNB_P360_DETAILS, PNB_GET_DOCS_VERSION_BY_PBDID,
    PNB_SAVE_EXIT_UPDATE_DOC,
    PNB_SAVE_EXIT_UPDATE_VERSION,
    PNB_DELETE_DOC,
    PNB_DELETE_VERSION,
    TOP_FILTER_EXTENDED_TIN,
    PNB_UHCI_DETAILS
,} from '@src/CommonComponents/constant/api_url_constants';
const _httpService = new httpService();
import { providerKeyData } from '@src/utility/common.service';
import {HEADER_DATA, providerProfileAncilalary, providerProfileFacility, providerProfileTierOne, currentStateAncillary, currentStateFacility, currentStateTierOne,} from "./constant";
import {nFormatterWithDollar} from "@src/utility/commonUtilityServices";
import { CAPTION_LABELS, FinancialParam, PrimaryObj, strategyNarative, Tactics, TiminCurrLandscape,
    LineOfBelow,PROPOSAL_IMPACT ,LINE_OF_BUSINESS,PROVIDER_DATA,CATEGORY_DATA,MERGER_ACQUISITION,
    LEADERSHIP_SIGN,ProviderNegotiationStrategyAncilliary,ProviderNegotiationStrategyFacility,
    ProviderNegotiationStrategytier,
    PnbOptions,
    timePeriod,BID_ASK_DATA, LEADERSHIP_SIGN_LABELS, BriefingInitiationDate, BriefingCompletionDate} from '../ProviderNegotiationStrategy/constants';
import { pnbConstants } from "@src/constants/pnb-constants";
import { pnbOptionsMapping } from './constant';
const apiDomainInternal = config('PNB_DOMAIN_INTERNAL');
let templateData = JSON.parse(sessionStorage.getItem('PNBData') ?? '{}');
_httpService.setBaseURL(apiDomainInternal);
const postApiCall = async (url: string, data: any) => {
    try {
        const response = await _httpService.push(
            url,
            data
          )
        return response;
    } catch (error) {
        console.error(`Error in POST API call to ${url}:`, error);
        throw error;
    }
};

const getPNBUHCIPayload = () => {
    let payload;
    const extractValues = (data: { value: string; title: string }[]): string[] => {
        return data.map(item => item.value);
    };
    if(templateData.length === 0){
        templateData = JSON.parse(sessionStorage.getItem('PNBData') ?? '{}');
    }
    if (templateData && templateData?.selectedTab?.key === 'TAX_ID') {
        payload = {
            "tins": extractValues(templateData.options).join(","),
            "customTinName": templateData.tinValue
          }
    } else if (templateData && templateData?.selectedTab?.key === 'HEALTH_SYSTEM') {
        payload = {
            "providerSysKey": templateData.healthSystemValue
            // "genId": templateData?.gensisId
          }
    }
    return payload;
}
const getTemplateType = () => {
    let payload;
    const extractValues = (data: { value: string; title: string }[]): string[] => {
        return data.map(item => item.value);
    };
    if (templateData && templateData?.selectedTab?.key === 'TAX_ID') {
        payload = {
            "tins": extractValues(templateData.options),
            "customTinName": templateData.tinValue,
            "templateName": templateData.templateValue.toUpperCase().replace(/& /g, '').replace(/ /g, '_').replace(/GROUP\b/g, 'GROUPS')
          }
    } else if (templateData && templateData?.selectedTab?.key === 'HEALTH_SYSTEM') {
        payload = {
            "genId": templateData?.gensisId,
            "templateName": templateData.templateValue.toUpperCase().replace(/& /g, '').replace(/ /g, '_').replace(/GROUP\b/g, 'GROUPS')
          }
    }
    return payload;
}

export const fetchAllUsers = async () => {
    const urlNdar = PNB_NDAR_DETAILS;
    const urlClm = PNB_CLM_DETAILS;
    const urlNpem = PNB_NPEM_DETAILS;
    const urlPdp = PNB_P360_DETAILS;
    const urlpuhci = PNB_UHCI_DETAILS;

    const data = getTemplateType();
    const uhcpayload = getPNBUHCIPayload();

    try {
        const apiCalls = [
            { key: 'response1', call: postApiCall(urlNdar, data) },
            { key: 'response2', call: postApiCall(urlClm, data) },
            { key: 'response3', call: postApiCall(urlNpem, data) },
            { key: 'response4', call: postApiCall(urlPdp, data) },
            { key: 'response5', call: postApiCall(urlpuhci, uhcpayload) },
        ];

        const responses = await Promise.all(apiCalls.map(api => api.call));

        const combinedResponse = apiCalls.reduce((acc, api, index) => {
            acc[api.key] = responses[index];
            return acc;
        }, {});

        return returnResponse(combinedResponse);
    } catch (error) {
        console.error('Error in making multiple POST API calls:', error);
        throw error;
    }
};

export const fetchGenesisIdFromUHCI = async (): Promise<string> => {
    const urlpuhci = PNB_UHCI_DETAILS;
    const uhcpayload = getPNBUHCIPayload();
    try {
        const response: any = await postApiCall(urlpuhci, uhcpayload);
        const genesisID = response?.data?.[0]?.providerProfile?.genesisID ?? '';
        return String(genesisID);
    } catch (error) {
        return '';
    }
};

const returnResponse = (combinedResponse) => {
    let finalResponse = {
        providerProfile: {},
        currentState: {},
        providerNegotioationStratergy: {},
        currentTime: "",
    };
    setProviderProfile(finalResponse, combinedResponse);
    setCurrentState(finalResponse, combinedResponse);
    setProviderNegotioationStratergy(finalResponse, combinedResponse);
    setTimeConversion(finalResponse, combinedResponse);
    Object.keys(CATEGORY_DATA).forEach((key) => {
        if (finalResponse.providerNegotioationStratergy[key]) {
            if (finalResponse.providerNegotioationStratergy[key].FirstOffer) {
                CATEGORY_DATA[key].FirstOffer = finalResponse.providerNegotioationStratergy[key].FirstOffer;
            }
        }
    });
    timePeriod.timing = String(finalResponse.currentTime);
    return finalResponse;
}
const setTimeConversion=(finalResponse, combinedResponse)=>{
if (combinedResponse?.response1 && combinedResponse?.response1?.timeStamp) {
    const timestamp = new Date(combinedResponse?.response1?.timeStamp);
    const formattedTimestamp = timestamp.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
    }).replace(',', '');
    finalResponse['currentTime'] = `Viewing data from ${formattedTimestamp}`;
}
}
const getJoinedOrDefault = (arr, key, defaultValue, addPercent = false) => {
    const values = Array.isArray(arr)
        ? arr.map(item => item[key]).filter(Boolean).map(val => addPercent ? `${val}%` : val)
        : [];
    return values.length > 0 ? values.join("; ") : defaultValue;
};

export const extractHospitalCostToChargeRatioObjects = (ahdDetailsArr) => {
    if (!Array.isArray(ahdDetailsArr)) return [];
    return ahdDetailsArr.map(item => {
        const fieldValue = item["Hospital Cost to Charge Ratio"] || "";
        let taxid = "";
        let taxName = "";
        if (item.tins) {
            const match = item.tins.match(/^(\d+)\(([^)]+)\)$/);
            if (match) {
                taxid = match[1];
                taxName = match[2];
            }
        }
        return {
            hospitalCostToChargeRatio: fieldValue,
            taxid,
            taxName
        };
    }).filter(obj => !!obj.hospitalCostToChargeRatio);
};

export const extractTinsInfoObjects = (ahdDetailsArr, fieldKey, outputKey) => {
    if (!Array.isArray(ahdDetailsArr)) return [];
    return ahdDetailsArr.map(item => {
        const fieldValue = item[fieldKey] || "";
        let taxid = "";
        let taxName = "";
        if (item.tins) {
            const match = item.tins.match(/^(\d+)\(([^)]+)\)$/);
            if (match) {
                taxid = match[1];
                taxName = match[2];
            }
        }
        return {
            [outputKey]: fieldValue,
            taxid,
            taxName
        };
    });
};
const setProviderProfile = (finalResponse, combinedResponse) => {
    let providerProfile: any = {};
    if (templateData.templateValue === PnbOptions.facility) {
        providerProfile = providerProfileFacility;
        providerProfile.providerName = getSafeValue('response5.data.0.providerProfile.providerName', combinedResponse);
        providerProfile.genesisID = getSafeValue('response5.data.0.providerProfile.genesisID', combinedResponse);
        providerProfile.totalHospitals = getSafeValue('response1.data.amaardiProviderSummary.HospitalCount', combinedResponse);
        providerProfile.ancillaryCount = getSafeValue('response1.data.amaardiProviderSummary.AncillaryCount', combinedResponse);
        providerProfile.providerGroupCount = getSafeValue('response1.data.amaardiProviderSummary.ProviderGroupCount', combinedResponse);
        providerProfile.totalBeds = getSafeValue('response1.data.totalHospitalBeds', combinedResponse);
        providerProfile.physicians = getSafeValue('response1.data.physicianCount', combinedResponse);
        providerProfile.privateEquityBacked.value = getSafeValue('response3.data.PrivateEquityBacked', combinedResponse);
        providerProfile.federallyQualifiedHeathCenters.FQHC = getSafeValue('response3.data.HealthCenterType.FQHC', combinedResponse);
        providerProfile.federallyQualifiedHeathCenters['FQHC LA'] = getSafeValue('response3.data.HealthCenterType.FQHC_LA', combinedResponse);
        providerProfile.federallyQualifiedHeathCenters.RHC = getSafeValue('response3.data.HealthCenterType.RHC', combinedResponse);
        providerProfile.federallyQualifiedHeathCenters.THC = getSafeValue('response3.data.HealthCenterType.THC', combinedResponse);
        providerProfile.spend['E&I Total'] = nFormatterWithDollar(getSafeValue('response4.data.payment.EI.EI Total', combinedResponse));
        providerProfile.spend.ASO = nFormatterWithDollar(getSafeValue('response4.data.payment.EI.ASO', combinedResponse));
        providerProfile.spend.FI = nFormatterWithDollar(getSafeValue('response4.data.payment.EI.FI', combinedResponse));
        providerProfile.spend['M&R'] = nFormatterWithDollar(getSafeValue('response4.data.payment.MR', combinedResponse));
        providerProfile.spend['C&S'] = nFormatterWithDollar(getSafeValue('response4.data.payment.CS', combinedResponse));
        providerProfile.spend.IFP = nFormatterWithDollar(getSafeValue('response4.data.payment.EXC', combinedResponse));
        providerProfile.spend.totalSpends = nFormatterWithDollar(getSafeValue('response4.data.payment.total', combinedResponse));
        providerProfile.isLegal = combinedResponse?.response3?.data?.UHGAffiliate?.Yes.length > 0 ? "Yes" : "No";
        const ahdDetails = combinedResponse?.response3?.data?.AHDDetails || [];

            const extractedProfitabilityPercentage = extractTinsInfoObjects(
                ahdDetails,
                "%Profitability",
                "profitabilityPercentage"
            ).filter(obj => !!obj["profitabilityPercentage"]);
        providerProfile.profitabilityPercentage = extractedProfitabilityPercentage.length > 0
                ? extractedProfitabilityPercentage
                : providerProfile.profitabilityPercentage;

            const extractedLeadership = extractTinsInfoObjects(
                ahdDetails,
                "Leadership-Group/System CEO Name",
                "leadership"
            ).filter(obj => !!obj["leadership"]);
        providerProfile.leadership = extractedLeadership.length > 0
                ? extractedLeadership
                : providerProfile.leadership;

            const extractedHeadquarters = extractTinsInfoObjects(
                ahdDetails,
                "Headquarters",
                "Headquarters"
            ).filter(obj => !!obj["Headquarters"]);
        providerProfile.Headquarters = extractedHeadquarters.length > 0
                ? extractedHeadquarters
                : providerProfile.Headquarters;

            const extractedFinancialStatus = extractTinsInfoObjects(
                ahdDetails,
                "Financial Status",
                "financialStatus"
            ).filter(obj => !!obj["financialStatus"]);
        providerProfile.financialStatus = extractedFinancialStatus.length > 0
                ? extractedFinancialStatus
                : providerProfile.financialStatus;


    } else if (templateData.templateValue === PnbOptions.ancillary) {
        providerProfile = providerProfileAncilalary;
        providerProfile.providerName = getSafeValue('response5.data.0.providerProfile.providerName', combinedResponse);
        providerProfile.genesisID = getSafeValue('response5.data.0.providerProfile.genesisID', combinedResponse);
        providerProfile.privateEquityBacked.value = getSafeValue('response3.data.PrivateEquityBacked', combinedResponse);
        providerProfile.totalHospitals = getSafeValue('response1.data.amaardiProviderSummary.HospitalCount', combinedResponse);
        providerProfile.ancillaryCount = getSafeValue('response1.data.amaardiProviderSummary.AncillaryCount', combinedResponse);
        providerProfile.providerGroupCount = getSafeValue('response1.data.amaardiProviderSummary.ProviderGroupCount', combinedResponse);
        providerProfile.spend['E&I'] = nFormatterWithDollar(getSafeValue('response4.data.payment.EI.EI Total', combinedResponse));
        providerProfile.spend['M&R'] = nFormatterWithDollar(getSafeValue('response4.data.payment.MR', combinedResponse));
        providerProfile.spend['C&S'] = nFormatterWithDollar(getSafeValue('response4.data.payment.CS', combinedResponse));
        providerProfile.spend.IFP = nFormatterWithDollar(getSafeValue('response4.data.payment.EXC', combinedResponse));
        providerProfile.spend.totalSpends = nFormatterWithDollar(getSafeValue('response4.data.payment.total', combinedResponse));
        providerProfile.isLegal = combinedResponse?.response3?.data?.UHGAffiliate?.Yes.length > 0 ? "Yes" : "No";
        const ahdDetails = combinedResponse?.response3?.data?.AHDDetails || [];
        const extractedLeadership = extractTinsInfoObjects(
                ahdDetails,
                "Leadership-Group/System CEO Name",
                "leadership"
            ).filter(obj => !!obj["leadership"]);
            providerProfile.leadership = extractedLeadership.length > 0
                ? extractedLeadership
                : providerProfile.leadership;

            const extractedHeadquarters = extractTinsInfoObjects(
                ahdDetails,
                "Headquarters",
                "Headquarters"
            ).filter(obj => !!obj["Headquarters"]);
            providerProfile.Headquarters = extractedHeadquarters.length > 0
                ? extractedHeadquarters
                : providerProfile.Headquarters;

            const extractedFinancialStatus = extractTinsInfoObjects(
                ahdDetails,
                "Financial Status",
                "financialStatus"
            ).filter(obj => !!obj["financialStatus"]);
            providerProfile.financialStatus = extractedFinancialStatus.length > 0
                ? extractedFinancialStatus
                : providerProfile.financialStatus;

    } else if (templateData.templateValue === PnbOptions.tier) {
        providerProfile = providerProfileTierOne;
        providerProfile.providerName = getSafeValue('response5.data.0.providerProfile.providerName', combinedResponse);
        providerProfile.genesisID = getSafeValue('response5.data.0.providerProfile.genesisID', combinedResponse);
        providerProfile.privateEquityBacked.value = getSafeValue('response3.data.PrivateEquityBacked', combinedResponse);
        providerProfile.spend['E&I Total'] = nFormatterWithDollar(getSafeValue('response4.data.payment.EI.EI Total', combinedResponse));
        providerProfile.spend.ASO = nFormatterWithDollar(getSafeValue('response4.data.payment.EI.ASO', combinedResponse));
        providerProfile.spend.FI = nFormatterWithDollar(getSafeValue('response4.data.payment.EI.FI', combinedResponse));
        providerProfile.spend['M&R'] = nFormatterWithDollar(getSafeValue('response4.data.payment.MR', combinedResponse));
        providerProfile.spend['C&S'] = nFormatterWithDollar(getSafeValue('response4.data.payment.CS', combinedResponse));
        providerProfile.spend.IFP = nFormatterWithDollar(getSafeValue('response4.data.payment.EXC', combinedResponse));
        providerProfile.spend.totalSpends = nFormatterWithDollar(getSafeValue('response4.data.payment.total', combinedResponse));
        providerProfile.isLegal = combinedResponse?.response3?.data?.UHGAffiliate?.Yes.length > 0 ? "Yes" : "No";
        const ahdDetails = combinedResponse?.response3?.data?.AHDDetails || [];
        const extractedLeadership = extractTinsInfoObjects(
                ahdDetails,
                "Leadership-Group/System CEO Name",
                "leadership"
            ).filter(obj => !!obj["leadership"]);
            providerProfile.leadership = extractedLeadership.length > 0
                ? extractedLeadership
                : providerProfile.leadership;

            const extractedHeadquarters = extractTinsInfoObjects(
                ahdDetails,
                "Headquarters",
                "Headquarters"
            ).filter(obj => !!obj["Headquarters"]);
            providerProfile.Headquarters = extractedHeadquarters.length > 0
                ? extractedHeadquarters
                : providerProfile.Headquarters;

            const extractedFinancialStatus = extractTinsInfoObjects(
                ahdDetails,
                "Financial Status",
                "financialStatus"
            ).filter(obj => !!obj["financialStatus"]);
            providerProfile.financialStatus = extractedFinancialStatus.length > 0
                ? extractedFinancialStatus
                : providerProfile.financialStatus;
    }
    providerProfile.providerName = providerProfile.providerName?.toUpperCase();
    return finalResponse.providerProfile = providerProfile;
}
export const getSafeValue = (path: string, obj: any, defaultValue: any = "") => {
    return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj) ?? defaultValue;
};
const getFormatRenewalTermDate = (data) => {
    return data?.map(item => {
        const { renewalTermDate, tins } = item;
        const separator = ', ';
        const lastSeparator = ' and ';
        const tinsFormatted = tins.length > 1
            ? tins.slice(0, -1).join(separator) + lastSeparator + tins.slice(-1)
            : tins[0];
        return `${tinsFormatted} have a renewal date of ${renewalTermDate}`;

    });
}
const getformatContractTermData = (data) => {
    return data?.map(item => {
        const { timePeriod, tins } = item;
        const separator = ', ';
        const lastSeparator = ' and ';
        const tinsFormatted = tins.length > 1
            ? tins.slice(0, -1).join(separator) + lastSeparator + tins.slice(-1)
            : tins[0];
        return `${tinsFormatted} have ${timePeriod} advance notice of term`;
    });
}
const setCurrentState = (finalResponse, combinedResponse) => {
    let currentState: any = {};
    if (templateData.templateValue === PnbOptions.ancillary) {
        currentState = currentStateAncillary;
        currentStateAncillary.currentContractTerms.currentContractTermRateProvision = getformatContractTermData(combinedResponse.response2.data.currentContractTermRateProvision);
        currentStateAncillary.currentContractTerms.renewalTermDate = getFormatRenewalTermDate(combinedResponse.response2.data.renewalTermDate);
        currentStateAncillary.currentContractTerms.previewRenewalTermDate = combinedResponse?.response2?.data?.renewalTermDate?.length > 0 ?   formatContractDates(combinedResponse?.response2?.data?.renewalTermDate, "date"): currentStateAncillary.currentContractTerms.previewRenewalTermDate;
        currentStateAncillary.currentContractTerms.previewCurrentContractTermRateProvision = combinedResponse?.response2?.data?.currentContractTermRateProvision?.length > 0 ?   formatContractDates(combinedResponse?.response2?.data?.currentContractTermRateProvision, "timePeriod"): currentStateAncillary.currentContractTerms.previewCurrentContractTermRateProvision;
      currentStateAncillary.operationsOverviewD.claimsYield.claimsYield = combinedResponse.response2.data.claimYieldResult;
      currentStateAncillary.operationsOverviewD.grossYield = combinedResponse.response2.data.grossYieldResult;
     } else if (templateData.templateValue === PnbOptions.facility) {
        currentState = currentStateFacility;
        // Legacy exclusions/exceptions are no longer returned by the API for fresh docs.
        // Remove the placeholder field so the new contractAllowance section renders instead.
        delete (currentStateFacility as any).exclusionsExceptions;

        currentStateFacility.contractAllowance.clinical = combinedResponse?.response5?.data[0]?.currentState?.Clinical?.data?.length >0
            ? formatAndSortExemptionData(combinedResponse?.response5.data[0].currentState.Clinical.data)
            : [];

        currentStateFacility.contractAllowance.paymentIntegrity = combinedResponse?.response5?.data[0]?.currentState?.PaymentIntegrity?.data?.length >0
            ? formatAndSortExemptionData(combinedResponse?.response5.data[0].currentState.PaymentIntegrity.data)
            : [];

        currentStateFacility.contractAllowance.paymentIntegrityClinical = combinedResponse?.response5?.data[0]?.currentState?.PaymentIntegrityClinical?.data?.length >0
            ? formatAndSortExemptionData(combinedResponse?.response5.data[0].currentState.PaymentIntegrityClinical.data)
            : [];

        currentStateFacility.contractAllowance.network = combinedResponse?.response5?.data[0]?.currentState?.Network?.data?.length >0
            ? formatAndSortExemptionData(combinedResponse?.response5.data[0].currentState.Network.data)
            : [];

        currentStateFacility.contractAllowance.pharmacy = combinedResponse?.response5?.data[0]?.currentState?.Pharmacy?.data?.length >0
            ? formatAndSortExemptionData(combinedResponse?.response5.data[0].currentState.Pharmacy.data)
            : [];

        currentStateFacility.contractAllowance.paymentIntegrityNonClinical = combinedResponse?.response5?.data[0]?.currentState?.PaymentIntegrityNonClinical?.data?.length >0
            ? formatAndSortExemptionData(combinedResponse?.response5.data[0].currentState.PaymentIntegrityNonClinical.data)
            : [];

        currentStateFacility.contractAllowance.paymentIntegrityReimbursementPolicy = combinedResponse?.response5?.data[0]?.currentState?.PaymentIntegrityReimbursementPolicy?.data?.length > 0
            ? formatAndSortExemptionData(combinedResponse?.response5.data[0].currentState.PaymentIntegrityReimbursementPolicy.data)
            : [];

        currentStateFacility.contractAllowance.other = combinedResponse?.response5?.data[0]?.currentState?.Other?.data?.length >0
            ? formatAndSortExemptionData(combinedResponse?.response5.data[0].currentState.Other.data)
            : [];

        currentStateFacility.marketCompetitiveness.providerBestInClassBICPayorName = combinedResponse?.response5.data[0].currentState.PayorDetails.BicNames.join(", ");
        currentStateFacility.marketCompetitiveness.uhcProviderNEF = combinedResponse?.response5.data[0].currentState.PayorDetails.NefScores.join(",");
        currentStateFacility.currentContractTerms.currentContractTermRateProvision = getformatContractTermData(combinedResponse.response2.data.currentContractTermRateProvision);
        currentStateFacility.currentContractTerms.renewalTermDate = getFormatRenewalTermDate(combinedResponse.response2.data.renewalTermDate);
        currentStateFacility.currentContractTerms.previewRenewalTermDate = combinedResponse?.response2?.data?.renewalTermDate?.length > 0 ?    formatContractDates(combinedResponse?.response2?.data?.renewalTermDate, "date"): currentStateFacility.currentContractTerms.previewRenewalTermDate;
        currentStateFacility.currentContractTerms.previewCurrentContractTermRateProvision = combinedResponse?.response2?.data?.currentContractTermRateProvision?.length > 0 ?   formatContractDates(combinedResponse?.response2?.data?.currentContractTermRateProvision, "timePeriod"): currentStateFacility.currentContractTerms.previewCurrentContractTermRateProvision;
        currentStateFacility.currentRelationshipContractDetails.narrative = combinedResponse.response1.data.productParticipation.length > 0 ? currentStateFacility.currentRelationshipContractDetails.narrative+ `\n\n${combinedResponse.response1.data.providerName} participates with ${combinedResponse.response1.data.productParticipation.join(", ")}` : currentStateFacility.currentRelationshipContractDetails.narrative;
        currentStateFacility.operationsOverview.claimsYeild = combinedResponse.response2.data.claimYieldResult;
        currentStateFacility.operationsOverview.grossYield = combinedResponse.response2.data.grossYieldResult;
        currentStateFacility.unitedHealthcareMembershipMarketSharePosition.lineOfBusiness = combinedResponse.response1.data?.uhcMembership && combinedResponse.response1.data.uhcMembership.length ? mergeLOBMembership(currentStateFacility.unitedHealthcareMembershipMarketSharePosition.lineOfBusiness, formatLOBDataCurrentState(combinedResponse.response1.data.uhcMembership)) : currentStateFacility.unitedHealthcareMembershipMarketSharePosition.lineOfBusiness;
        const ahdDetails = combinedResponse?.response3?.data?.AHDDetails || [];
        const extractedHospitalCostToChargeRatio = extractHospitalCostToChargeRatioObjects(ahdDetails);

        currentStateFacility.contractRateMethodologyCompetitivenessOverviewByLineOfBusiness.commercial.hospitalCostToChargeRatio =
            extractedHospitalCostToChargeRatio.length > 0
            ? extractedHospitalCostToChargeRatio
            : currentStateFacility.contractRateMethodologyCompetitivenessOverviewByLineOfBusiness.commercial.hospitalCostToChargeRatio;

    } else if (templateData.templateValue === PnbOptions.tier) {
        currentState = currentStateTierOne;
        currentStateTierOne.currentContractTerms.currentContractTermRateProvision = getformatContractTermData(combinedResponse.response2.data.currentContractTermRateProvision);
        currentStateTierOne.currentContractTerms.renewalTermDate = getFormatRenewalTermDate(combinedResponse.response2.data.renewalTermDate);
        currentStateTierOne.currentContractTerms.previewRenewalTermDate =    combinedResponse?.response2?.data?.renewalTermDate?.length > 0 ?   formatContractDates(combinedResponse?.response2?.data?.renewalTermDate, "date"): currentStateTierOne.currentContractTerms.previewRenewalTermDate;
        currentStateTierOne.currentContractTerms.previewCurrentContractTermRateProvision = combinedResponse?.response2?.data?.currentContractTermRateProvision?.length > 0 ?   formatContractDates(combinedResponse?.response2?.data?.currentContractTermRateProvision, "timePeriod") : currentStateTierOne.currentContractTerms.previewCurrentContractTermRateProvision;
        currentStateTierOne.currentRelationshipContractDetails.narrative = combinedResponse.response1.data.productParticipation.length > 0 ? currentStateTierOne.currentRelationshipContractDetails.narrative+ `\n\n${combinedResponse.response1.data.providerName} participates with ${combinedResponse.response1.data.productParticipation.join(", ")}` : currentStateTierOne.currentRelationshipContractDetails.narrative;
        // Legacy exclusions/exceptions are no longer returned by the API for fresh docs.
        // Remove the placeholder field so the new contractAllowance section renders instead.
       delete (currentStateTierOne as any).exclusionsExceptions;

        currentStateTierOne.contractAllowance.clinical = combinedResponse?.response5?.data[0]?.currentState?.Clinical?.data?.length >0
            ? formatAndSortExemptionData(combinedResponse?.response5.data[0].currentState.Clinical.data)
            : [];

        currentStateTierOne.contractAllowance.paymentIntegrity = combinedResponse?.response5?.data[0]?.currentState?.PaymentIntegrity?.data?.length >0
            ? formatAndSortExemptionData(combinedResponse?.response5.data[0].currentState.PaymentIntegrity.data)
            : [];

        currentStateTierOne.contractAllowance.paymentIntegrityClinical = combinedResponse?.response5?.data[0]?.currentState?.PaymentIntegrityClinical?.data?.length >0
            ? formatAndSortExemptionData(combinedResponse?.response5.data[0].currentState.PaymentIntegrityClinical.data)
            : [];

        currentStateTierOne.contractAllowance.network = combinedResponse?.response5?.data[0]?.currentState?.Network?.data?.length >0
            ? formatAndSortExemptionData(combinedResponse?.response5.data[0].currentState.Network.data)
            : [];

        currentStateTierOne.contractAllowance.pharmacy = combinedResponse?.response5?.data[0]?.currentState?.Pharmacy?.data?.length >0
            ? formatAndSortExemptionData(combinedResponse?.response5.data[0].currentState.Pharmacy.data)
            : [];

        currentStateTierOne.contractAllowance.paymentIntegrityNonClinical = combinedResponse?.response5?.data[0]?.currentState?.PaymentIntegrityNonClinical?.data?.length >0
            ? formatAndSortExemptionData(combinedResponse?.response5.data[0].currentState.PaymentIntegrityNonClinical.data)
            : [];

        currentStateTierOne.contractAllowance.paymentIntegrityReimbursementPolicy = combinedResponse?.response5?.data[0]?.currentState?.PaymentIntegrityReimbursementPolicy?.data?.length > 0
            ? formatAndSortExemptionData(combinedResponse?.response5.data[0].currentState.PaymentIntegrityReimbursementPolicy.data)
            : [];

        currentStateTierOne.contractAllowance.other = combinedResponse?.response5?.data[0]?.currentState?.Other?.data?.length >0
            ? formatAndSortExemptionData(combinedResponse?.response5.data[0].currentState.Other.data)
            : [];

        currentStateTierOne.operationsOverview.claimsYeild = combinedResponse.response2.data.claimYieldResult;
        currentStateTierOne.operationsOverview.grossYield = combinedResponse.response2.data.grossYieldResult;
        currentStateTierOne.unitedHealthcareMembershipMarketSharePosition.lineOfBusiness = combinedResponse.response1.data?.uhcMembership && combinedResponse.response1.data?.uhcMembership?.length ? mergeLOBMembership(currentStateTierOne.unitedHealthcareMembershipMarketSharePosition.lineOfBusiness, formatLOBDataCurrentState(combinedResponse.response1.data.uhcMembership)) : currentStateTierOne.unitedHealthcareMembershipMarketSharePosition.lineOfBusiness
    } else {
        currentState = currentStateFacility;
    }
    return finalResponse.currentState = currentState;
}



const formatContractDates = (data?: any[], type?: string): { timePeriod: string; tin: string; provider: string }[] => {
    if (!data || !Array.isArray(data)) {
        return [];
    }

    return data.flatMap(item => {
        if (!item?.tins || !Array.isArray(item.tins)) {
            return [];
        }

        return item.tins.map(tin => {
            const result = extractProviderAndTin(tin);
            return {
                timePeriod: type === "date" ? item.renewalTermDate : `${item.timePeriod} ${pnbConstants.ADVANCE_NOTICE_TERM}`,
                tin: result?.tinNumber || "",
                provider: result?.providerName || ""
            };
        });
    });
};

const extractProviderAndTin = (input: string) => {
    const match = input.match(/^(.*)\((\d+)\)$/);
    if (match) {
        const providerName = match[1].trim();
        const tinNumber = match[2].trim();
        return { providerName, tinNumber };
    }
    return {providerName: "", tinNumber: ""};
};
const setProviderNegotioationStratergy = (finalResponse, combinedResponse) => {
    let providerNegotiationStrategy: any = {
        ...getPnsDefaultValues()
    };

    const formatNegotiationValue = (value) => `${Math.floor(value) % 10}%`;

    if (combinedResponse?.response4?.data?.payment?.CS || combinedResponse?.response4?.data?.payment?.MR ||
        combinedResponse?.response4?.data?.payment?.EI?.["EI Total"] || combinedResponse?.response4?.data?.payment?.EXC
    ) {
    try{
    // Ensure the category holders exist before assigning first-offer values.
    // getPnsDefaultValues() does not seed CS/MR/EI/IFP, so guard against undefined.
    providerNegotiationStrategy.CS = providerNegotiationStrategy.CS || {};
    providerNegotiationStrategy.MR = providerNegotiationStrategy.MR || {};
    providerNegotiationStrategy.EI = providerNegotiationStrategy.EI || {};
    providerNegotiationStrategy.IFP = providerNegotiationStrategy.IFP || {};
    providerNegotiationStrategy.CS.FirstOffer = formatNegotiationValue(combinedResponse.response4.data.payment.CS);
    providerNegotiationStrategy.MR.FirstOffer = formatNegotiationValue(combinedResponse.response4.data.payment.MR);
    providerNegotiationStrategy.EI.FirstOffer = formatNegotiationValue(combinedResponse.response4.data.payment.EI["EI Total"]);
    providerNegotiationStrategy.IFP.FirstOffer = formatNegotiationValue(combinedResponse.response4.data.payment.EXC);
    } catch (error) {
        console.error("Error processing negotiation strategy values:", error);
      }
    }

    return finalResponse.providerNegotioationStratergy = providerNegotiationStrategy;
};

export const saveAndExit = async (type="generate", payload:any="") => {
    try {
        const apiDomainInternal = config('PNB_DOMAIN_INTERNAL');
        _httpService.setBaseURL(apiDomainInternal);
        const responseData: any = await _httpService.push(type == "generate" ? PNB_SAVE_EXIT_UPDATE_DOC : PNB_SAVE_EXIT_UPDATE_VERSION, payload);
        return responseData;
      } catch {
          return null;
      }
}

export const deleteDocument = async (type:any="", payload:any="") => {
    try {
        const apiDomainInternal = config('PNB_DOMAIN_INTERNAL');
        _httpService.setBaseURL(apiDomainInternal);
        const responseData: any = await _httpService.push(type == "all" ? PNB_DELETE_DOC : PNB_DELETE_VERSION, payload);
        return responseData;
      } catch {
          return null;
      }
}

const getPnsDefaultValues = () => {
    return {
        strategyNarative: strategyNarative?.fieldText || '',
        primaryObjective: PrimaryObj?.fieldText || '',
        tactics: Tactics?.fieldText || '',
        proposalImpact: PROPOSAL_IMPACT,
        lineOfBusiness: LINE_OF_BUSINESS,
        LineOfBelow: LineOfBelow?.fieldText || '',
        categoryData: CATEGORY_DATA,
        mergerAcquisition: MERGER_ACQUISITION,
        providerData: PROVIDER_DATA,
        leadershipSgn: LEADERSHIP_SIGN,
        leadershipSgnLabels: LEADERSHIP_SIGN_LABELS,
        FinancialParam: FinancialParam?.fieldText || '',
        strategyApproc: strategyNarative?.fieldText || '',
        bidAskData: BID_ASK_DATA,
        briefingInitiationDate: BriefingInitiationDate?.fieldText || '',
        briefingCompletionDate: BriefingCompletionDate?.fieldText || ''
    }
}

function extractProvisionDetailsFromText(
    textArray: string[]
  ): { provider: string; tin: string; timePeriod: string; }[] {
    const result: { provider: string; tin: string; timePeriod: string }[] = [];

  textArray.forEach((text) => {
    // Match provider names and TINs
    const providerTinRegex = /([\w\s&',\-\/]+?)\((\d{9})\)/g;
    // Match time period and advance notice
    const timePeriodRegex = /(\d+\sYears|N\/A)(?:\sdeal)?\s\/\s(\d+\sdays|N\/A)(?:\sadvance\snotice\sof\sterm)?/;

    // Extract time period in the format "3 Years / 180 days"
    const timePeriodMatch = text.match(timePeriodRegex);
    let timePeriod = timePeriodMatch
      ? `${timePeriodMatch[1]} / ${timePeriodMatch[2]}`
      : pnbConstants.NA;

    timePeriod = `${timePeriod} ${pnbConstants.ADVANCE_NOTICE_TERM}`;

    let match;
    while ((match = providerTinRegex.exec(text)) !== null) {
      // Remove commas and the word "and" from the provider name
      const providerName = match[1].trim().replace(/,/g, '').replace(/\sand\s/g, ' ');
      const tin = match[2].trim();

      result.push({ provider: providerName, tin, timePeriod });
    }
  });

    return result;
}

function extractRenewalDateDetails(data: string[]): { provider: string; tin: string; timePeriod: string }[] {
    try{
        const result: { provider: string; tin: string; timePeriod: string }[] = [];

    data?.forEach((entry) => {
        // Regex to match provider names and TINs (e.g., "Name(TIN)")
        const providerTinRegex = /^(.*?)\((\d{9})\)/;
        // Regex to match the renewal date (e.g., "MM/DD/YYYY")
        const dateRegex = /renewal date of (\d{2}\/\d{2}\/\d{4})/;

        // Extract provider and TIN
        const providerTinMatch = entry.match(providerTinRegex);
        const providerName = providerTinMatch ? providerTinMatch[1].trim() : '';
        const tin = providerTinMatch ? providerTinMatch[2].trim() : '';

        // Extract the renewal date
        const dateMatch = entry.match(dateRegex);
        const timePeriod = dateMatch ? dateMatch[1] : '';

        // Push the extracted details into the result array
        if (providerName && tin && timePeriod) {
            result.push({
                provider: providerName,
                tin: tin,
                timePeriod: timePeriod,
            });
        }
    });

    return result;} catch (error) {
        console.error("Error extracting renewal date details:", error);
        return [];
    }
}

export const fetchUsersByPid = async (pid: string) => {
    const url = PNB_GET_DOCS_VERSION_BY_PBDID+'/'+pid;
    try {
        const response:any = await _httpService.push(url,{});
        const data = JSON.parse(response.data[0].document);
        if(data.profile?.optumControl) {
            delete data.profile?.optumControl;
        }
        data.negotiationStrategy = {
            ...getPnsDefaultValues(),
            ...data.negotiationStrategy
        }
        if (!data.currentState?.currentContractTerms?.previewRenewalTermDate?.length && Array.isArray(data.currentState?.currentContractTerms?.renewalTermDate)) {
            data.currentState.currentContractTerms.previewRenewalTermDate = extractRenewalDateDetails(data.currentState?.currentContractTerms?.renewalTermDate);
        }
        if (!data.currentState?.currentContractTerms?.previewCurrentContractTermRateProvision?.length && Array.isArray(data.currentState?.currentContractTerms?.currentContractTermRateProvision)) {
            data.currentState.currentContractTerms.previewCurrentContractTermRateProvision = extractProvisionDetailsFromText(data.currentState?.currentContractTerms?.currentContractTermRateProvision);
        }
        // Format the exemption end dates for sorting
        if (data.currentState?.exclusionsExceptions?.affordability) {
            let editedData = parseExemptionProgramDetails(data.currentState.exclusionsExceptions.affordability);
            data.currentState.exclusionsExceptions.affordability = formatAndSortExemptionData(editedData);
        }
        if (typeof data?.currentState?.unitedHealthcareMembershipMarketSharePosition?.lineOfBusiness?.commercial?.membership == "string") {
            if (!data.currentState.unitedHealthcareMembershipMarketSharePosition.lineOfBusiness['marketName']) {
                data.currentState.unitedHealthcareMembershipMarketSharePosition.lineOfBusiness['marketName'] = {};
            }
            data.currentState.unitedHealthcareMembershipMarketSharePosition.lineOfBusiness['marketName']['membership'] = [pnbConstants.XXM, pnbConstants.XXM, pnbConstants.XXM];
            data.currentState.unitedHealthcareMembershipMarketSharePosition.lineOfBusiness.commercial.membership = [data?.currentState.unitedHealthcareMembershipMarketSharePosition?.lineOfBusiness?.commercial?.membership, pnbConstants.XXM, pnbConstants.XXM];
            data.currentState.unitedHealthcareMembershipMarketSharePosition.lineOfBusiness.medicaid.membership = [data?.currentState.unitedHealthcareMembershipMarketSharePosition?.lineOfBusiness?.medicaid?.membership, pnbConstants.XXM, pnbConstants.XXM];
            data.currentState.unitedHealthcareMembershipMarketSharePosition.lineOfBusiness.ifp.membership = [data.currentState.unitedHealthcareMembershipMarketSharePosition.lineOfBusiness.ifp.membership, pnbConstants.XXM, pnbConstants.XXM];
            data.currentState.unitedHealthcareMembershipMarketSharePosition.lineOfBusiness.medicare.membership = [data.currentState.unitedHealthcareMembershipMarketSharePosition.lineOfBusiness.medicare.membership, pnbConstants.XXM, pnbConstants.XXM];
        }

        sessionStorage.removeItem('PNBData');

        // Build a complete payload for session storage
        let payload:any = {
            "searchValue": "",
        };

        // Ensure templateValue is always set
        if (response.data[0].templateType && pnbOptionsMapping[response.data[0].templateType]) {
            payload.templateValue = pnbOptionsMapping[response.data[0].templateType];
        }
        if(response.data[0].hcoId !== null && response.data[0].genId !== null){
            payload.selectedTab = {key: 'HEALTH_SYSTEM'};
            payload.healthSystemValue = response.data[0].hcoId;
            payload.gensisId = response.data[0].genId;
        }else if(response.data[0].tin !== null && response.data[0].tinName !== null){
            payload.options = response.data[0].tin ? response.data[0].tin.split(',').map(tin => ({
                value: tin.trim(),
                title: ''
            })) : [];
            payload.selectedTab = {key: 'TAX_ID'};
            payload.tinValue = response.data[0].tinName;
        }
        sessionStorage.setItem('PNBData', JSON.stringify(payload));
        templateData = JSON.parse(sessionStorage.getItem('PNBData') || '{}');

        let finalResponse = {
            providerProfile: data.profile,
            currentState: data.currentState,
            providerNegotioationStratergy: data.negotiationStrategy ?? {},
            currentTime:data?.currentTime ?? "",
            documentId: response.data[0].docId,
            templateType: response.data[0].templateType,
            headerData: response.data[0],
            headerName: response.data[0].hcoName !== null ? response.data[0].hcoName : response.data[0].tinName
        }
        return finalResponse;
    } catch (error) {
        console.error('Error in making POST API call:', error);
        throw error;
    }
};

/**
 * Converts an array of objects with countsByLob string property into objects with individual LOB count properties
 * @param inputArray Array containing objects with countsByLob string and marketName
 * @returns Array of objects with individual LOB count properties
 */
export const formatLOBDataCurrentState = (inputArray) => {
    if (!inputArray || !Array.isArray(inputArray)) {
        return [];
    }

    return inputArray.map(item => {
        if (!item.countsByLob) {
            return item;
        }

        // Extract the content between square brackets
        const countsStr = item.countsByLob.substring(
            item.countsByLob.indexOf('[') + 1,
            item.countsByLob.lastIndexOf(']')
        );

        // Create a new object with the marketName
        const result: any = { marketName: item.marketName };

        // Split by comma and process each LOB count pair
        countsStr.split(', ').forEach(pair => {
            // Extract LOB name and count from each pair (e.g., "Commercial:274178")
            const [lob, countStr] = pair.split(':');
            if (lob && countStr) {
                // Convert count to number if possible, otherwise keep as string
                const count = !isNaN(parseFloat(countStr)) ? parseFloat(countStr) : countStr;
                result[lob] = count;
            }
        });

        return result;
    });
};

export const getLOBDataByKey = (data, key) => {
    let membership: any = [];
    data.map(item => {
        membership.push(item[key]);
    })
    return membership;
}

export const mergeLOBMembership = (defaultData: any, APIData) => {
    defaultData.marketName.membership = getLOBDataByKey(APIData, "marketName");
    defaultData.commercial.membership = getLOBDataByKey(APIData, "Commercial");
    defaultData.medicare.membership = getLOBDataByKey(APIData, "Medicaid");
    defaultData.medicaid.membership = getLOBDataByKey(APIData, "Medicare");
    defaultData.ifp.membership = getLOBDataByKey(APIData, "IFP");
    return defaultData;
}

// Helper function to parse MM/DD/YYYY dates correctly for sorting
const parseMMDDYYYYDate = (dateStr) => {
    if (!dateStr || dateStr === pnbConstants.NA) return null;

    // For MM/DD/YYYY format, convert to YYYY-MM-DD for reliable parsing
    const parts = dateStr.split('/');
    if (parts.length === 3) {
        // Handle far-future dates (like 12/31/9999) by returning a special maximum date
        if (parts[2] === "9999") return new Date(8640000000000000); // Max date JavaScript can handle

        const month = parts[0].padStart(2, '0');
        const day = parts[1].padStart(2, '0');
        const year = parts[2];
        return new Date(`${year}-${month}-${day}`);
    }

    // Fallback to standard date parsing
    return isNaN(Date.parse(dateStr)) ? null : new Date(dateStr);
};

const setDisplayTinFlag = (data) => {
    //  object to count frquecencies of each ProgramName
    const programNameObj = {};

    data?.forEach(item => {
        const programName = item?.ProgramName;
        if (programNameObj[programName]) {
            programNameObj[programName]++;
        } else {
            programNameObj[programName] = 1;
        }
    });
    data?.forEach(item => {
        const programName = item?.ProgramName;
        // If the program name appears more than once, we have to display TIN
        if (programNameObj[programName] > 1) {
            item['displayTin'] = true;
        } else {
            // If it appears only once, no need to display TIN, set displayTin to false
            item['displayTin'] = false;
        }
    });
    return data;
}

export const formatAndSortExemptionData = (data: any = []) => {
    if (!data || !data.length) return [];
    return setDisplayTinFlag(data)
        .map(item => ({
            ...item,
            formattedExemptionEndDate: parseMMDDYYYYDate(item.ExemptionEndDate)
        }))
        .sort((a, b) => {
            // Sort by end date in descending order (latest dates first)
            if (a.formattedExemptionEndDate && b.formattedExemptionEndDate) {
                return b.formattedExemptionEndDate - a.formattedExemptionEndDate;
            }
            // Put items with no end date (null) at the end
            else if (a.formattedExemptionEndDate) {
                return -1; // Item with date comes first
            } else if (b.formattedExemptionEndDate) {
                return 1; // Item with date comes first
            }
            // If both have no end date, maintain original order
            return 0;
        })
        .map(item => {
            const startDate = item.ExemptionStartDate === pnbConstants.NA ? pnbConstants.NO_START_DATE : item.ExemptionStartDate;
            const endDate = item.ExemptionEndDate === pnbConstants.NA ? pnbConstants.NO_END_DATE : item.ExemptionEndDate;
            const isDefaultHelper = (!item.ExemptionStartDate || item.ExemptionStartDate === pnbConstants.NA) && (!item.ExemptionEndDate || item.ExemptionEndDate === pnbConstants.NA);
            if (isDefaultHelper) {
                return item.ProgramName;
            }
            return item?.displayTin
                ? item.ExemptionStartDate
                    ? item.ProgramName + " (" + startDate + " - " + endDate + ")" +
                        (item.TIN && item.TIN.length > 0 ? " \u2013 " + item.TIN + " (" + item.TINNAME + ")" : "")
                    : item.ProgramName + " " + startDate + " - " + endDate +
                        (item.TIN && item.TIN.length > 0 ? " \u2013 " + item.TIN + " (" + item.TINNAME + ")" : "")
                : item.ExemptionStartDate
                    ? item.ProgramName + " (" + startDate + " - " + endDate + ")"
                    : item.ProgramName + " " + startDate + " - " + endDate;

        });
};

/**
 * Parses exemption program details from formatted strings
 *
 * @param exemptionStrings Array of strings in format "Program Name (start date - end date) - TIN (TIN Name)"
 * @returns Array of structured exemption objects with ProgramName, ExemptionStartDate, ExemptionEndDate, TIN, and TINNAME
 */
export function parseExemptionProgramDetails(exemptionStrings: string[]): Array<{
  ProgramName: string;
  ExemptionStartDate: string;
  ExemptionEndDate: string;
  TIN: string;
  TINNAME: string;
  displayTin?: boolean;
}> {
    if (!exemptionStrings || exemptionStrings.length === 0 || exemptionStrings[0] === "") {
        return [];
    }
  if (!exemptionStrings || !Array.isArray(exemptionStrings) || exemptionStrings.length === 0 || exemptionStrings[0].trim() == "[Name of Exemptions] [Expiration dates]") {
    return exemptionStrings.map(exemptionString => ({
        ProgramName: exemptionString,
        ExemptionStartDate: "",
        ExemptionEndDate: "",
        TIN: "",
        TINNAME: ""
    }));
  }

  return exemptionStrings.map(exemptionString => {
    // Check for special case with no dates (just "APRN" for example)
    if (!exemptionString.includes('(')) {
      return {
        ProgramName: exemptionString.trim(),
        ExemptionStartDate: pnbConstants.NA,
        ExemptionEndDate: pnbConstants.NA,
        TIN: '',
        TINNAME: ''
      };
    }

    // Case 1: Program with dates and TIN info
    // Example: "Medication Sourcing Expansion (02/06/2020 - 06/30/2025) - 1234 (Test)"
    const fullPattern = /^(.*?)\s*\(([^-]+)(?:\s*-\s*([^)]+))?\)\s*(?:–|-)\s*([^(]+)(?:\s*\(([^)]+)\))?$/;
    const match = exemptionString.match(fullPattern);

    if (match) {
      const programName = match[1]?.trim() || '';
      const startDate = match[2]?.trim() || pnbConstants.NA;
      const endDate = match[3]?.trim() || pnbConstants.NA;
      const tin = match[4]?.trim() || '';
      const tinName = match[5]?.trim() || '';

      // Handle special case: "No Start Date/No End Date"
      if (startDate === `${pnbConstants.NO_START_DATE}/${pnbConstants.NO_END_DATE}`) {
        const [noStartDate, noEndDate] = startDate.split('/');
        return {
          ProgramName: programName,
          ExemptionStartDate: noStartDate.trim() || pnbConstants.NA,
          ExemptionEndDate: noEndDate.trim() || pnbConstants.NA,
          TIN: tin,
          TINNAME: tinName
        };
      }

      return {
        ProgramName: programName,
        ExemptionStartDate: startDate,
        ExemptionEndDate: endDate,
        TIN: tin,
        TINNAME: tinName
      };
    }

    // Case 2: Program with inline dates but no explicit TIN section
    // Example: "Radiology and Cardiology Prior Authorization (08/07/2017 - 12/31/9999)"
    const simplePattern = /^(.*?)\s*\(([^-]+)(?:\s*-\s*([^)]+))?\)$/;
    const simpleMatch = exemptionString.match(simplePattern);

    if (simpleMatch && simpleMatch[2]?.trim() === `${pnbConstants.NO_START_DATE}/${pnbConstants.NO_END_DATE}`) {
        return {
            ProgramName: simpleMatch[1]?.trim() || '',
            ExemptionStartDate: pnbConstants.NA,
            ExemptionEndDate: pnbConstants.NA,
            TIN: '',
            TINNAME: ''
        };
    }

    if (simpleMatch) {
      return {
        ProgramName: simpleMatch[1]?.trim() || '',
        ExemptionStartDate: simpleMatch[2]?.trim() || pnbConstants.NA,
        ExemptionEndDate: simpleMatch[3]?.trim() || pnbConstants.NA,
        TIN: '',  // Always add default N/A for TIN
        TINNAME: '' // Always add default N/A for TINNAME
      };
    }
    // Fallback for unmatched patterns
    return {
      ProgramName: exemptionString,
      ExemptionStartDate: pnbConstants.NA,
      ExemptionEndDate: pnbConstants.NA,
      TIN: '',
      TINNAME: ''
    };
  });
}